import { useOptionalPredictionsContext } from '@src/providers/PredictionsProvider';
import { getPredictionEventTitleForSecurity } from '@src/types/PredictionMarket';
import type { Security } from '@talos/kyoko';
import { useMemo } from 'react';

export function usePredictionEventTitle(security: Security | undefined): string | undefined {
  const predictionsContext = useOptionalPredictionsContext();

  return useMemo(() => {
    if (!security) {
      return undefined;
    }
    return getPredictionEventTitleForSecurity(security, predictionsContext?.eventsByID);
  }, [predictionsContext?.eventsByID, security]);
}
